module.exports = __webpack_public_path__ + "static/media/Hannah Mount Headshot_1591180091909.2cac0866.jpg";